import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M23.8348 8.49981L11.9999 0.807129L0.165039 8.49981L11.9999 16.1925L19.9999 10.9925V15.9998H21.9999V9.6925L23.8348 8.49981Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M5 17.4997V13.835L11.9999 18.385L19 13.835V17.4997C19 18.9695 17.986 20.1153 16.7465 20.8384C15.4825 21.5757 13.8021 21.9997 12 21.9997C10.1979 21.9997 8.51754 21.5757 7.25349 20.8384C6.01399 20.1153 5 18.9695 5 17.4997Z"}}]};

const EducationFilled = Vue.extend<IconProps>({
  name: 'EducationFilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'education-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default EducationFilled;
